const getIntersectionChecksResult = (
  intersections: boolean[],
): boolean => intersections.every((intersect) => !intersect);

export default getIntersectionChecksResult;
